const type = 'SET_PCI_CARD_ERROR';

const setPCICardError = () => ({
  type,
});

export default setPCICardError;
